import { getAllUrlParams, buildQuerystring } from '../jslibs/urlparams';
export const SESSIONSTORE_QUERYSTRING = 'querystringParameters';

/**
 * @returns useable saved querystring in format 'param1=x&param2=y'
 */
export const retrieveSavedQuerystring = () : string =>
{
    const storage = window.sessionStorage;
    return buildQuerystring(JSON.parse(storage.getItem(SESSIONSTORE_QUERYSTRING) ?? '{}'));
};

/**
 * creates or updates saves query string parameters. 
 * @param url current url with query parameters
 * @returns boolean true when succeeds, false when unable to save
 */
export const createUpdateSavedQuerystringParameters = (url: string) : boolean =>
{
    const storage = window.sessionStorage;
    const newParams = getAllUrlParams(url);
    let currentParams = JSON.parse(storage.getItem(SESSIONSTORE_QUERYSTRING) ?? '{}');
    
    Object.assign(currentParams, newParams);

    try {
        storage.setItem(SESSIONSTORE_QUERYSTRING, JSON.stringify(currentParams));
        return true;
    }
    catch {
        return false;
    }
};